import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {AssistanceApplication, AssistanceApplicationType, User} from '../../../../../../../../services/api.client';
import {AssistanceApplicationStatus} from '../../../../../../../../shared/enums/assistance-application-status';
import {PromptComponent} from '../../../../../../../shared/dialogs/PromptComponent';

@Component({
    selector: 'app-assistance-application-basic-audit',
    templateUrl: './assistance-application-basic-audit.component.html',
    styleUrls: ['./assistance-application-basic-audit.component.scss'],
    standalone: false
})
export class AssistanceApplicationBasicAuditComponent {
    @Input() assistanceApplication: AssistanceApplication;
    @Input() assistanceApplicationId: string;
    @Input() user: User;

    @Output() submitReadyForReview = new EventEmitter<void>();

    @ViewChild('infoRequestModal') infoRequestModal: PromptComponent;
    @ViewChild('passReviewModal') passReviewModal: PromptComponent;
    @ViewChild('denyReviewModal') denyReviewModal: PromptComponent;

    get canReview(): boolean {
        return this.user?.canReviewApplications &&
            this.assistanceApplication?.status === AssistanceApplicationStatus.UnderReview;
    }

    get canSubmitReadyForReview(): boolean {
        return this.assistanceApplication?.status === AssistanceApplicationStatus.InfoNeeded
            && !!this.assistanceApplication?.currentInformationRequest;
    }

    get isStlWaterApplication(): boolean {
        const type = this.assistanceApplication?.applicationType;
        if (typeof type === 'number') {
            return type === AssistanceApplicationType.STLWater;
        }
        return AssistanceApplicationType[type as keyof typeof AssistanceApplicationType] === AssistanceApplicationType.STLWater;
    }

    getApplicationStatusText(): string {
        switch (this.assistanceApplication?.status) {
            case AssistanceApplicationStatus.Approved:
                return 'Approved';
            case AssistanceApplicationStatus.UnderReview:
                return 'Under Review';
            case AssistanceApplicationStatus.ReviewPassed:
                return 'Passed Review';
            case AssistanceApplicationStatus.Denied:
                return 'Denied';
            case AssistanceApplicationStatus.InfoNeeded:
                return 'Information Needed';
            case AssistanceApplicationStatus.Submitted:
                return 'Submitted';
            default:
                return '';
        }
    }

    getApplicationIconClasses(): string {
        switch (this.assistanceApplication?.status) {
            case AssistanceApplicationStatus.Approved:
                return 'fa fa-check-circle-o status-icon-green';
            case AssistanceApplicationStatus.UnderReview:
                return 'fa fa-hourglass-half status-icon-blue';
            case AssistanceApplicationStatus.ReviewPassed:
                return 'fa fa-check-circle-o status-icon-green';
            case AssistanceApplicationStatus.Denied:
                return 'fa fa-exclamation-circle status-icon-red';
            case AssistanceApplicationStatus.InfoNeeded:
                return 'fa fa-info-circle status-icon-amber';
            case AssistanceApplicationStatus.Submitted:
                return 'fa fa-paper-plane-o';
            default:
                return '';
        }
    }

    public async setReadyForReview(): Promise<void> {
        this.submitReadyForReview.emit();
    }

    showInfoRequestModal(): void {
        this.infoRequestModal?.open();
    }

    onClickCancelInfoRequest(): void {
        this.infoRequestModal?.close();
    }

    showPassReviewModal(): void {
        this.passReviewModal.open();
    }

    onClickCancelPassReview(): void {
        this.passReviewModal.close();
    }

    showDenyReviewModal(): void {
        this.denyReviewModal.open();
    }

    onClickCancelDenyReview(): void {
        this.denyReviewModal.close();
    }
}
